import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Button } from "components/button"
import { BlogCard } from "../BlogCard/BlogCard"
import { BlogPosts, GraphQLBlogPostsData } from "./blog-banner-types"
import { useLayout } from "contexts/components/LayoutContext"
import "./blog-banner.module.scss"

interface BlogBannerProps {
  heading: string | null
  sub_heading?: string | null
}

export const BlogBanner = ({ heading, sub_heading }: BlogBannerProps) => {
  const { parentSlug } = useLayout()
  const { posts } = useStaticQuery<GraphQLBlogPostsData>(
    getBlogBannerFooterPosts
  )

  const getBlogArticles = (posts: BlogPosts) => {
    if (posts?.edges?.length === 0) return <></>
    return posts?.edges?.map(({ node }) => {
      const {
        featured_image,
        id,
        meta_data,
        post_abstract,
        post_title,
        published_date,
        slug,
      } = node

      return (
        <BlogCard
          customOverlayCTAText={meta_data?.overlay_cta_text}
          featured_image={featured_image}
          hasDateTag
          key={id}
          post_abstract={post_abstract}
          post_title={post_title}
          published_date={published_date}
          slug={slug}
        />
      )
    })
  }

  return (
    <section className="fr-blog-banner alternate-background-color">
      <div className="fr-container fr-blog-banner__wrapper">
        {heading && (
          <div className="fr-blog-banner__heading-container">
            <h2 className="fr-blog-banner__heading">{heading}</h2>

            {sub_heading && <h3>{sub_heading}</h3>}
          </div>
        )}
        <div
          className={`fr-blog-banner__blog-list${
            posts.edges.length === 1 ? "--1" : ""
          }`}
        >
          {getBlogArticles(posts)}
        </div>
        <Button
          children="Read All Articles"
          variant="outline-secondary"
          extraClassNames="fr-blog-banner__btn"
          to={parentSlug ? `/${parentSlug}` : "/blog"}
        />
      </div>
    </section>
  )
}

const getBlogBannerFooterPosts = graphql`
  query getBlogBannerFooterPosts {
    posts: allStrapiBlog(
      sort: { fields: published_date, order: DESC }
      limit: 2
      filter: { post_url: { ne: "demo-blog" } }
    ) {
      edges {
        node {
          id
          meta_data {
            overlay_cta_text
          }
          post_title
          post_abstract
          featured_image {
            ...StrapiImageFragment
          }
          published_date(formatString: "MMMM DD, YYYY")
          slug: post_url
        }
      }
    }
  }
`

export const blogFooterQuery = graphql`
  fragment StrapiBlogBannerGlobalFooterFragment on STRAPI__COMPONENT_GLOBAL_FOOTER_GLOBAL_FOOTER_BLOG_BANNER {
    strapi_component
    id
    eyebrow_text
    heading
    sub_heading
  }
`
